/**
 * @generated SignedSource<<961ab9a88f73c12bb857a9e9a343455e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AssignAgentsDialogBulkMoveItemsToAgentPoolMutation$variables = {
  agentPoolRawId: string;
  agentTypeRawIds: ReadonlyArray<string>;
  authorizedAgentRawIds: ReadonlyArray<string>;
  unauthorizedAgentRawIds: ReadonlyArray<string>;
};
export type AssignAgentsDialogBulkMoveItemsToAgentPoolMutation$data = {
  readonly bulkAuthorizeAgents: {
    readonly agents: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null;
  readonly bulkMoveAgentsToAgentPool: {
    readonly targetAgentPool: {
      readonly id: string;
    } | null;
  } | null;
  readonly bulkMoveCloudImagesToAgentPool: {
    readonly targetAgentPool: {
      readonly id: string;
    } | null;
  } | null;
};
export type AssignAgentsDialogBulkMoveItemsToAgentPoolMutation = {
  response: AssignAgentsDialogBulkMoveItemsToAgentPoolMutation$data;
  variables: AssignAgentsDialogBulkMoveItemsToAgentPoolMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentPoolRawId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentTypeRawIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "authorizedAgentRawIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "unauthorizedAgentRawIds"
},
v4 = {
  "kind": "Variable",
  "name": "targetAgentPoolRawId",
  "variableName": "agentPoolRawId"
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
],
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AgentPool",
    "kind": "LinkedField",
    "name": "targetAgentPool",
    "plural": false,
    "selections": (v5/*: any*/),
    "storageKey": null
  }
],
v7 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "agentTypeRawIds",
            "variableName": "agentTypeRawIds"
          },
          (v4/*: any*/)
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "BulkMoveCloudImagesToAgentPoolPayload",
    "kind": "LinkedField",
    "name": "bulkMoveCloudImagesToAgentPool",
    "plural": false,
    "selections": (v6/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "agentRawIds",
            "variableName": "authorizedAgentRawIds"
          },
          (v4/*: any*/)
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "BulkMoveAgentsToAgentPoolPayload",
    "kind": "LinkedField",
    "name": "bulkMoveAgentsToAgentPool",
    "plural": false,
    "selections": (v6/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "agentRawIds",
            "variableName": "unauthorizedAgentRawIds"
          },
          (v4/*: any*/)
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "BulkAuthorizeAgentsPayload",
    "kind": "LinkedField",
    "name": "bulkAuthorizeAgents",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Agent",
        "kind": "LinkedField",
        "name": "agents",
        "plural": true,
        "selections": (v5/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignAgentsDialogBulkMoveItemsToAgentPoolMutation",
    "selections": (v7/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AssignAgentsDialogBulkMoveItemsToAgentPoolMutation",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "925ca1e1aa28d0ea5e13ea40c4c4c0c1",
    "id": null,
    "metadata": {},
    "name": "AssignAgentsDialogBulkMoveItemsToAgentPoolMutation",
    "operationKind": "mutation",
    "text": "mutation AssignAgentsDialogBulkMoveItemsToAgentPoolMutation(\n  $agentTypeRawIds: [ID!]!\n  $authorizedAgentRawIds: [ID!]!\n  $unauthorizedAgentRawIds: [ID!]!\n  $agentPoolRawId: ID!\n) {\n  bulkMoveCloudImagesToAgentPool(input: {agentTypeRawIds: $agentTypeRawIds, targetAgentPoolRawId: $agentPoolRawId}) {\n    targetAgentPool {\n      id\n    }\n  }\n  bulkMoveAgentsToAgentPool(input: {agentRawIds: $authorizedAgentRawIds, targetAgentPoolRawId: $agentPoolRawId}) {\n    targetAgentPool {\n      id\n    }\n  }\n  bulkAuthorizeAgents(input: {agentRawIds: $unauthorizedAgentRawIds, targetAgentPoolRawId: $agentPoolRawId}) {\n    agents {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "49adf2da1adaf8a76f92601bd7dc789a";

export default node;
